import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import {
  ProgramHeaderRightActionsButton,
  ProgramHeaderRightActionsButtonSuspense,
} from "@/modules/programs/components/programHeader/programHeaderRightActionsButton"
import { useProgram } from "@/modules/programs/hooks/usePrograms"
import { useSessionSidebar } from "@/modules/sessions/sessionForm/hooks/useSessionSidebar"
import { PencilIcon, PlusIcon } from "lucide-react"
import { Suspense } from "react"

type ProgramHeaderRightViewProps = {
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramHeaderRightView({ programId, className, ...props }: ProgramHeaderRightViewProps) {
  const { navigateToSessionForm } = useSessionSidebar()
  const { data: program } = useProgram(programId)
  return (
    <div
      className={cn(
        "flex h-52 min-w-100 flex-col justify-between rounded-3xl bg-surface-background-secondary p-4",
        className,
      )}
      {...props}
    >
      <div className="flex flex-col items-center justify-center gap-2 text-textOnSurface-muted">
        <PencilIcon color="currentColor" width={32} height={32} />
        <Text fontStyle="TM">{word("global.action.plural", { count: 1 })}</Text>
      </div>
      <div className="flex flex-col gap-3">
        <Button variant="primary" size="md" onClick={() => void navigateToSessionForm(program)} className="grow">
          <PlusIcon color="currentColor" width={24} height={24} />
          {word("menu.session.detail")}
        </Button>
        <Suspense fallback={<ProgramHeaderRightActionsButtonSuspense />}>
          <ProgramHeaderRightActionsButton programId={programId} />
        </Suspense>
      </div>
    </div>
  )
}
